import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CartVoucherService } from '@spartacus/cart/base/core';
import { Voucher } from '@spartacus/cart/base/root';
import { ICON_TYPE } from 'src/app/custom/icons/icon.model';

@Component({
  selector: 'cx-applied-coupons',
  templateUrl: './custom-applied-coupons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomAppliedCouponsComponent {
  @Input()
  vouchers: Voucher[];
  @Input()
  cartIsLoading = false;
  @Input()
  isReadOnly = false;

  iconTypes = ICON_TYPE;

  constructor(
    protected cartVoucherService: CartVoucherService
  ) { }

  public get sortedVouchers(): Voucher[] {
    this.vouchers = this.vouchers || [];
    return this.vouchers.slice().sort((a, b) => {
      return a.code.localeCompare(b.code);
    });
  }

  removeVoucher(voucherId: string) {
    this.cartVoucherService.removeVoucher(voucherId);
  }
}
